import { parseISO } from 'date-fns';
import { QUICK_DATE_FILTER_ALL_TIME } from '../../common/constants';
import type { QUICK_DATE_FILTER, ZoomState } from '../../common/types';
import { QUICK_DATE_FILTER_LABELS_BY_VALUE } from './constants';
import type { ControlsState } from './types';

export const getControlsStateFromZoom = (
	zoomState: ZoomState,
	quickDateFilter: QUICK_DATE_FILTER,
): ControlsState => {
	if (zoomState.type === 'none') {
		return {
			selectedOption: QUICK_DATE_FILTER_LABELS_BY_VALUE[QUICK_DATE_FILTER_ALL_TIME],
			fromDate: '',
			toDate: '',
		};
	}

	if (zoomState.type === 'percentage') {
		return {
			selectedOption: QUICK_DATE_FILTER_LABELS_BY_VALUE[quickDateFilter],
			fromDate: '',
			toDate: '',
		};
	}

	return {
		selectedOption: QUICK_DATE_FILTER_LABELS_BY_VALUE[quickDateFilter],
		fromDate: zoomState.startValue != null ? new Date(zoomState.startValue) : '',
		toDate: zoomState.endValue != null ? new Date(zoomState.endValue) : '',
	};
};

export const parseDatePickerDate = (value: string): Date => new Date(parseISO(value));
